import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UpdateOrganizationV1OrganizationsOrgIdPutData,
  type UpdateOrganizationV1OrganizationsOrgIdPutError,
  type UpdateOrganizationV1OrganizationsOrgIdPutResponse,
  updateOrganizationV1OrganizationsOrgIdPut,
} from '../../generated';

export type UpdateOrganizationMutationVariables = UpdateOrganizationV1OrganizationsOrgIdPutData['path'] &
  UpdateOrganizationV1OrganizationsOrgIdPutData['body'];

export type UpdateOrganizationMutation = UpdateOrganizationV1OrganizationsOrgIdPutResponse;

export const useUpdateOrganizationMutation = <
  TError = UpdateOrganizationV1OrganizationsOrgIdPutError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UpdateOrganizationMutation, TError, UpdateOrganizationMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UpdateOrganizationMutation, TError, UpdateOrganizationMutationVariables, TContext>({
    mutationKey: ['UpdateOrganization'],
    mutationFn: async ({ org_id, ...body }: UpdateOrganizationMutationVariables) => {
      const { data } = await updateOrganizationV1OrganizationsOrgIdPut({
        path: { org_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUpdateOrganizationMutation.fetcher = (
  { org_id, ...body }: UpdateOrganizationMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await updateOrganizationV1OrganizationsOrgIdPut({
      path: { org_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
